// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { DonutChartContainer } from '@shared/ui-kit/components';
import { useAssetVehicles } from '../hooks/use-asset-vehicles';
import { useTranslation } from 'react-i18next';
import { Translation } from '@shared/ui-kit/providers/translation-provider/translation';

export const AssetVehiclesChart = () => {
  const { t } = useTranslation();
  const { assetsVehicles } = useAssetVehicles();

  const assetsVehiclesNames: Record<string, string> = {
    stock: t('glossary.stock', { ns: 'glossary' }),
    etf: t('glossary.etf', { ns: 'glossary' }),
    other: t('glossary.other', { ns: 'glossary' }),
    cash: t('glossary.cash', { ns: 'glossary' }),
    mutual_fund: t('glossary.mutual-fund', { ns: 'glossary' }),
  };

  const labels = Object.keys(assetsVehicles).map(key => assetsVehiclesNames[key]);
  const values = Object.values(assetsVehicles);

  return (
    <DonutChartContainer
      name={<Translation i18nKey="dashboard.asset-vehicles" ns="dashboard" />}
      exposure={labels}
      weight={values}
      testId="asset-vehicles-chart"
      popupName="dashboard.assetVehicles"
      noDataMessage={t('dashboard.asset-vehicle-data-unavailable', {
        ns: 'dashboard',
      })}
    />
  );
};
